/*
*
* File JS per la Single Product
*
*/


// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper, { Navigation, Pagination, Thumbs } from 'swiper';
Swiper.use([Navigation, Pagination, Thumbs]);

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import cardProduct from 'components/card-product/card-product';
import 'components/form/form'

// //--------------------------------------------------------------------//

// // IMPORT STILE SPECIFICO PAGINA
// //--------------------------------------------------------------------//

import './single-product.scss';

// //--------------------------------------------------------------------//

// // INIT COMPONENTI
// //--------------------------------------------------------------------//

//Sposta il Recaptcha in fondo al form
function enableReCaptchaInline() {
    const form = document.querySelector('.block-contact-form__container');

    const checkBadge = setInterval(function() {
        const badge = document.querySelector('.grecaptcha-badge');

        if (badge && form) {
            form.appendChild(badge);
            clearInterval(checkBadge);
        }
    }, 500);
}

document.addEventListener("DOMContentLoaded", function() {
    enableReCaptchaInline();
});

const gallery = ()  => {
    let gallery = document.querySelector('.single-product__image--wrap');
    if(!gallery) return;

    const wrapperGallery = document.querySelector('.single-product__image--wrap .gallery-thumbs');
    if(wrapperGallery){        
        let argsThumb = {
            spaceBetween: 5,
            slidesPerView: 'auto',
            freeMode: true,
            loop: false,
            watchSlidesProgress: true,
        }
        let galleryThumbs = new Swiper(wrapperGallery, argsThumb);
    
        let argsGallery = {
            slidesPerView: 1,
            spaceBetween: 5,
            loop: false,
            thumbs: {
                swiper: galleryThumbs,
            },
        };
        let gallerySwiper = new Swiper(gallery.querySelector('.gallery'), argsGallery);
    }



    let galleryRelated = document.querySelector('.products_related');
    if (galleryRelated) {
        let argsGalleryRelated = {
            slidesPerView: 3,
            spaceBetween: 20,
            breakpoints: {
                0: {
                    slidesPerView: 1.2,
                },
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                1024: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                }
            },
            modules: [Navigation, Pagination],
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                type: 'bullets',
                clickable: true
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification'
            },
        };
        let gallerySwiperRelated = new Swiper(galleryRelated.querySelector('.gallery_related'), argsGalleryRelated);
    }
}
gallery();

export default gallery;

// //--------------------------------------------------------------------//